import produce from 'immer'
import { toast } from 'react-toastify'

import {
  CLEAR,
  PARSE_CSV_FILE,
  PARSE_CSV_FILE_FAILURE,
  PARSE_CSV_FILE_SUCCESS,
  POST_ZIP_FILE,
  POST_ZIP_FILE_FAILURE,
  POST_ZIP_FILE_SUCCESS,
  SET_PARSE_CSV_FILE_RESULT,
  SET_POST_ZIP_FILE_RESULT,
} from '../actions/batchProductCreator'
import { POST_A_PRODUCT_SUCCESS } from '../actions/products'
import { BatchProductCreatorActions, BatchProductCreatorState } from '../types/batchProductCreator'

const initialState: BatchProductCreatorState = {
  zipFileResult: null,
  csvFileResult: null,
  createdProducts: [],
  loading: false,
}

export const batchProductCreatorReducer = produce(
  (state: BatchProductCreatorState, action: BatchProductCreatorActions) => {
    switch (action.type) {
      case PARSE_CSV_FILE:
        state.loading = true
        return
      case PARSE_CSV_FILE_SUCCESS:
        state.loading = false
        return
      case PARSE_CSV_FILE_FAILURE:
        state.loading = false
        const message =
          action?.payload?.errorMessage ||
          'Error in CSV file, make sure the file is properly formatted and try again.'
        toast(message, { containerId: 'error', toastId: 'post-csv-file-failure' })
        return
      case POST_ZIP_FILE:
        state.loading = true
        return
      case POST_ZIP_FILE_SUCCESS:
        state.loading = false
        return
      case POST_ZIP_FILE_FAILURE:
        state.loading = false
        toast('Error in ZIP file', {
          containerId: 'error',
          toastId: 'post-zip-file-failure',
        })
        return
      case SET_POST_ZIP_FILE_RESULT:
        state.zipFileResult = action.payload.zipFileResult
        return
      case SET_PARSE_CSV_FILE_RESULT:
        state.csvFileResult = action.payload.csvFileResult
        return
      case POST_A_PRODUCT_SUCCESS:
        const { batchCreationIndex } = action.meta.originalPayload
        if (batchCreationIndex === null || batchCreationIndex === undefined) {
          return
        }
        state.createdProducts.push({
          batchCreationIndex: batchCreationIndex,
          productId: action.payload.data.product.id,
          productName: action.payload.data.product.name,
        })
        return

      case CLEAR:
        state.csvFileResult = null
        state.zipFileResult = null
        state.loading = false
        state.createdProducts = []
        return
    }
  },
  initialState
)
